import {
  Directive,
  Input,
  Inject,
  HostBinding,
  HostListener,
  ElementRef,
  Optional,
  Renderer2,
} from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { Router } from '@angular/router';
import { WindowService } from '@cigna/shared/angular/core/window-util';

interface LinkObject {
  path: string;
  openExternal: boolean;
}

@Directive({
  selector: 'a[cignaLink]',
})
export class NavigationLinkDirective {
  private _isSpa = true;
  private _hostname: string;

  constructor(
    @Inject(APP_BASE_HREF) private _baseHref: string,
    private _el: ElementRef,
    private _renderer: Renderer2,
    windowService: WindowService,
    @Optional() private _router?: Router,
  ) {
    this._hostname = windowService.location.hostname;
  }

  @HostBinding('attr.href')
  public href: string | null;

  @Input()
  set cignaLink(urlOrLink: string | LinkObject) {
    let url = '';
    let isExternal = false;
    let isSpa = false;

    if (!urlOrLink) {
      this.href = null;
      return;
    }

    if (typeof urlOrLink === 'string') {
      url = urlOrLink;
      isExternal = this.isExternalUrl(url);
      isSpa = url.startsWith(this._baseHref) && !isExternal;
    } else {
      url = urlOrLink.path;
      isExternal = urlOrLink.openExternal;
      isSpa = url.startsWith(this._baseHref) && !isExternal;
    }

    if (isSpa) {
      this.href = url.substring(this._baseHref.length);
      this._isSpa = true;
      return;
    }

    if (isExternal) {
      this._renderer.setAttribute(
        this._el.nativeElement,
        'target',
        !url.includes('/claims/onlinesubmission') ? '_blank' : '_self',
        // above used to prevent internal links from creating new tabs, but allows a page post back
      );
    }

    this.href = url;
    this._isSpa = false;
  }

  @HostListener('click')
  public onClick() {
    if (this._isSpa && this._router && this.href) {
      this._router.navigateByUrl(this.href);

      return false;
    }

    return true;
  }

  private isExternalUrl(url: string): boolean {
    if (url.startsWith('http')) {
      const urlHostname = new URL(url).hostname;

      if (!urlHostname.startsWith(this._hostname)) {
        return true;
      }
    }

    return false;
  }
}
